module.exports = ".background{\r\n\tbackground: url('/assets/GMHDOBRASIL.png') no-repeat;\r\n\tbackground-position: center 420px;\r\n\tbackground-size: 500px;\r\n\tposition: fixed;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tz-index: -2;\r\n\tdisplay: block;\r\n\twidth:100%;\r\n\theight: 100%;\r\n\t-webkit-filter: grayscale(90%);\r\n\t        filter: grayscale(90%);\r\n\topacity: 0.08;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main